<div class="bmc-connect-replication-detail">
  <bzg-tab-set class="bz-env-component-tabs" (onSelectTab)="selectedTab = $event.index">
    <bzg-tab-item [ngClass]="{'active-tab': selectedTab === 0}" displayName="{{'PROVIDERS.REPLICATION.PROPERTIES' | translate | uppercase}}">
      <connect-replication-detail-properties [currentItemSelected]="currentItemSelected"></connect-replication-detail-properties>
    </bzg-tab-item>
    <bzg-tab-item [ngClass]="{'active-tab': selectedTab === 1}" displayName="{{'PROVIDERS.REPLICATION.SCHEDULE' | translate | uppercase}}">
      <connect-replication-detail-schedule [currentItemSelected]="currentItemSelected"></connect-replication-detail-schedule>
    </bzg-tab-item>
    <bzg-tab-item [ngClass]="{'active-tab': selectedTab === 2}" displayName="{{'PROVIDERS.REPLICATION.ENTITIES' | translate | uppercase}}">
      <connect-replication-detail-log [currentItemSelected]="currentItemSelected"></connect-replication-detail-log>
    </bzg-tab-item>
  </bzg-tab-set>
</div>
